export default{
  ERROR:{
        LOGIN:{
            USER_EMPTY:'Username is empty!',
            PASSWORD_EMPTY:'Password is empty!',
            LOGIN_FAILED:'Login Failed',
            LOGIN_SUCCESS:'Login Success',
            LOGIN_FAILED_FALSE_CREDENTIAL:'Login Failed, make sure your username and password are correct',
        },
        REQUEST:{
            TOKEN_NOT_PROVIDED : "Authentication credentials were not provided.",
        },
        MASTER_TABLE:{
          ONERROR:"Failed to get master properties"
        },
        MODEL:{
          NOTE:{
            FORM:{
              VALIDATION:{
                TITLE_EMPTY: "Title's is Empty!",
                DESCRIPTION_EMPTY: "Description's is Empty!",
              }
            }
          },
          COMMENT:{
            FORM:{
              VALIDATION:{
                COMMENT_EMPTY: 'Comment is Empty',
              }
            }
          },
          ASSET:{
            FORM:{
              VALIDATION:{
                TAG_EMPTY              :"Asset's tag is Empty!",
                NAME_EMPTY             :"Asset's name is Empty!",
                TYPE_EMPTY             :"Asset's type is Empty!",
                SERIAL_NUMBER_EMPTY    :"Asset's serial number is Empty!",
                DESCRIPTION_EMPTY      :"Description's is Empty!",
                PURCHASED_DATE_EMPTY   :"Asset's purchased date is Empty!",
                PURCHASE_CURRENCY_EMPTY:"Asset's purchase currency is Empty!",
                PURCHASE_PRICE_EMPTY   :"Asset's purchase price is Empty!",
                PURCHASE_ORDER_EMPTY   :"Asset's purchase order is Empty!",
                PURCHASE_VENDOR_EMPTY  :"Asset's puchase vendor is Empty!",
                STATUS_EMPTY           :"Asset's status is Empty!",
                SITE_EMPTY             :"Asset's site is Empty!",
                LOCATION_EMPTY         :"Asset's location is Empty!",
                MAX_DAY_EMPTY           :"Asset's maxday is Empty!",
                NOT_EDITABLE           :"Form is Not Editable",
              }
            },
            FETCH:{
              READ:"There's something went wrong while trying to get asset data, "
            }
          },
          TRACKING:{
            FORM:{
              VALIDATION:{
                SITE_EMPTY:"Site is Empty!",
                LOCATION_EMPTY:"Location is Empty!",
              }
            },
            FETCH:{
              READ:"There's something went wrong while trying to get asset data, "
            }
          },
          LOCATION:{
            FORM:{
              VALIDATION:{
                NAME_EMPTY:"Location name is empty!",
                CONTACT_EMPTY:"Contact is empty!",
                SITE_EMPTY:"Site is empty!",
              }
            },
            FETCH:{
              READ:"There's something went wrong while trying to get asset data, "
            }
          },
          SITE:{
            FORM:{
              VALIDATION:{
                NAME_EMPTY:"Site's name is Empty!",
                TAG_EMPTY:"Site's tag is Empty!",
                TYPE_EMPTY:"Site's type is Empty!",
                ADDRESS_EMPTY:"Site's address is Empty!",
                CITY_EMPTY:"Site's city is Empty!",
                POSTAL_EMPTY:"Site's postal is Empty!",
                LONGITUDE_EMPTY:"Site's longitude is Empty!",
                LATITUDE_EMPTY:"Site's Latitude is Empty!",
                STATUS_EMPTY:"Site's Status is Empty!",
                PROJECT_NAME_EMPTY:"Site's project name is Empty!",
                CONTACT_EMPTY:"Site's contact is Empty",
              }
            },
            FETCH:{
              READ:"There's something went wrong while trying to get asset data, "
            }
          },
          CITY_COVERAGE:{
            FORM:{
              VALIDATION:{
                CITY_EMPTY:"City is Empty!",
              }
            },
            FETCH:{
              READ:"There's something went wrong while trying to get asset data, "
            }
          },
          ASSET_STATUS:{
            FORM:{
              VALIDATION:{
                NAME_EMPTY:"Name is Empty!",
              }
            },
            FETCH:{
              READ:"There's something went wrong while trying to get asset data, "
            }
          },
          MAINTENANCE_TYPE: {
            FORM:{
              VALIDATION:{
                NAME_EMPTY:"Name is Empty!",
                DESCRIPTION_EMPTY:"Description is Empty!",
                DURATION_EMPTY:"Duration is Empty!",
              }
            }
          },
          CONTACT:{
            FORM:{
              VALIDATION:{
                NAME_EMPTY:"Name is Empty!",
                PHONE_EMPTY:"Phone is Empty!",
                PHONE_INVALID:"Phone is Invalid!",
                EMAIL_EMPTY:"Email is Empty!",
                EMAIL_INVALID:"Email is not valid!",
              }
            },
            FETCH:{
              READ:"There's something went wrong while trying to get asset data, "
            }
          },
          USER:{
            FORM:{
              VALIDATION:{
                USERNAME_EMPTY:"Username is Empty!",
                USERNAME_INVALID:"Username is Invalid!",
                FIRST_NAME_EMPTY:"First name is Empty!",
                LAST_NAME_EMPTY:"Last name is Empty!",
                EMAIL_EMPTY:"Email is Empty!",
                EMAIL_INVALID:"Email is not valid!",
                TAG_EMPTY:"Tag is Empty!",
                ADDRESS_EMPTY:"Address is Empty!",
                ROLE_EMPTY:"Role is Empty!",
                PASSWORD_EMPTY:"Password is Empty!",
                OLD_PASSWORD_EMPTY:"Old password is Empty!",
                NEW_PASSWORD_EMPTY:"New password is Empty!",
              }
            },
            FETCH:{
              READ:"There's something went wrong while trying to get asset data, "
            }
          },
          CONTRACTOR:{
            FORM:{
              VALIDATION:{
                NAME_EMPTY:"Name is Empty!",
              }
            },
            FETCH:{
              READ:"There's something went wrong while trying to get contractor data, "
            }
          },
          ERROR_SUBMIT:"Oops, something went wrong, ",
        },

  },

  SUCEESS:{
    MODEL:{
      NOTE:{
        REGISTRATION: "New note has been successfully added",
        DELETE:"Note deleted",
        UPDATE:"Note has been successfully updated",
      },
      COMMENT: {
        REGISTRATION: "New comment has been successfully added",
      },
      ASSET:{
        REGISTRATION:"New asset has been successfully added",
        DELETE:"Asset deleted",
        UPDATE:"Asset has been successfully updated",
      },
      TRACKING:{
        REGISTRATION:"New asset tracking has been successfully added",
        DELETE:"Tracking asset deleted",
        UPDATE:"Tracking asset has been successfully updated",
      },
      LOCATION:{
        REGISTRATION:"New Location has been successfully added",
        DELETE:"Location deleted",
        UPDATE:"Location has been successfully updated",
      },
      SITE:{
        REGISTRATION:"New site has been successfully added",
        DELETE:"Site deleted",
        UPDATE:"Site has been successfully updated",
      },
      CITY_COVERAGE:{
        REGISTRATION:"New city coverage has been successfully added",
        DELETE:"City Coverage deleted",
      },
      ASSET_STATUS:{
        REGISTRATION:"New asset status has been successfully added",
        DELETE:"Asset status deleted",
        UPDATE:"Asset status has been successfully updated",
      },
      ASSET_TYPE:{
        REGISTRATION:"New asset type has been successfully added",
        DELETE:"Asset type deleted",
        UPDATE:"Asset type has been successfully updated",
      },
      BUSINESS_MODEL:{
        REGISTRATION:"New business model has been successfully added",
        DELETE:"Business model deleted",
        UPDATE:"Business model has been successfully updated",
      },
      DEPARTEMENT:{
        REGISTRATION:"New department has been successfully added",
        DELETE:"Department deleted",
        UPDATE:"Department has been successfully updated",
      },
      SITE_STATUS:{
          REGISTRATION:"New site status has been successfully added",
          DELETE:"Site status deleted",
          UPDATE:"Site status has been successfully updated",
        },
      MAINTENANCE_TYPE:{
        REGISTRATION:"New maintenance type has been successfully added",
        DELETE:"Maintenance type deleted",
        UPDATE:"Maintenance type has been successfully updated",
      },
      SITE_TYPE:{
          REGISTRATION:"New site type has been successfully added",
          DELETE:"Site type deleted",
          UPDATE:"Site type has been successfully updated",
        },
      CONTACT:{
          REGISTRATION:"New contact has been successfully added",
          DELETE:"Contact deleted",
          UPDATE:"Contact has been successfully updated",
        },
      ROLE:{
          REGISTRATION:"New role has been successfully added",
          DELETE:"Role deleted",
          UPDATE:"Role has been successfully updated",
      },
      CONTRACTOR:{
          REGISTRATION:"New contractor has been successfully added",
          DELETE:"Contractor deleted",
          UPDATE:"Contractor has been successfully updated",
      },
      USER:{
          REGISTRATION:"New user has been successfully added",
          DELETE:"User deleted",
          UPDATE:"User has been successfully updated",
          SELF_UPDATE:"Your information has been updated",
          PASSWORD_UPDATE:"You password has been updated"
      },
      UPLOAD:"Upload successful",
      DELETE:"Delete Successful"
    },
  },
  
  PERMISSION:{
    DONT_HAVE_ACCESS:"You don't have access to perform this action"
  },
}



// WEBPACK FOOTER //
// ./src/App/config/message.js